module.exports = __webpack_public_path__ + "static/Collins-SQL-certification-8886c067fd42fea12a321da83cf564c4.png";